import React from 'react'
import { l, SectionMessage } from '@manychat/manyui'

import { useAppSelector } from 'reduxTyped'
import { GoalTypeHint } from 'apps/aiAutomation/components/EngagementGoalEditor/components/GoalTypeHint'
import { MAX_GOALS_NUMBER } from 'apps/aiAutomation/lib/goals'
import { AiAutomationEngagementGoalSelectors } from 'apps/aiAutomation/store/engagementGoal'
import { GoalStatus } from 'shared/api/requests/aiEngagementGoal/schemas'

import { useSelectedGoalData } from '../../hooks/useSelectedGoalData'

export const ContextualHint = () => {
  const { selectedGoal, goalType } = useSelectedGoalData()

  const isActiveGoalLimitReached = useAppSelector(
    AiAutomationEngagementGoalSelectors.getIsActiveGoalLimitReached,
  )

  return (
    <div>
      {selectedGoal?.status !== GoalStatus.ACTIVE && isActiveGoalLimitReached && (
        <SectionMessage
          className="m-b-lg"
          variant="warning"
          title={l.translate("You've reached your AI goal limit")}
          description={l.translate(
            'You can only run {maxGoals} at once. Save this as a draft and turn one off in Overview',
            {
              maxGoals: MAX_GOALS_NUMBER,
            },
          )}
        />
      )}

      <GoalTypeHint type={goalType} />
    </div>
  )
}
